import script from "./forklift.konveyor.io.provider.vue?vue&type=script&lang=js"
export * from "./forklift.konveyor.io.provider.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__